<template>
  <div class="sc-control-header">
    <i-switch v-model="contract[type]" @on-change="changeHandler" />
    <span class="ms-help">
      {{ contract[type] ? "Включено" : "Отключено" }}
    </span>
  </div>
</template>

<script>
export default {
  props: ['contract', 'type'],
  methods: {
    changeHandler (value) {
      if (!value) {
        const propsToClear = ['amount', 'percentage', 'condition']

        propsToClear.forEach(prop =>
          this.$set(this.contract, `${this.type}_${prop}`, 0)
        )
        this.$set(this.contract, `${this.type}_stages`, [])
        this.$set(this.contract, `${this.type}_condition_date`, null)
        this.contract.roadmaps.forEach(r =>
          this.$set(r, `${this.type}_value`, 0)
        )

        if (this.type === 'prepaid') {
          this.$set(this.contract, 'payment_tasks', [])
        }
      }
    }
  }
}
</script>

<style lang="less">
.sc-control-header {
  margin-bottom: 8px;

  .ms-help {
    margin-left: 4px;
  }
}
</style>
